'use client'

import Image from 'next/image'
import Link from 'next/link'
import { useEffect, useState } from 'react'

interface ThemeLogoProps {
  size?: 'small' | 'medium' | 'large'
  increasedSize?: boolean
  variant?: 'words' | 'icon'
  linkDisabled?: boolean
}

export function ThemeLogo({ size = 'medium', increasedSize = false, variant = 'icon', linkDisabled = false }: ThemeLogoProps) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return (
      <div className={`bg-transparent ${
        size === 'small' ? `w-${increasedSize ? '[50px]' : '10'} h-${increasedSize ? '[50px]' : '10'}` :
        size === 'large' ? `w-${increasedSize ? '40' : '32'} h-${increasedSize ? '40' : '32'}` :
        `w-${increasedSize ? '[120px]' : '24'} h-${increasedSize ? '[120px]' : '24'}`
      }`} />
    )
  }
  
  const logoSrc = variant === 'words' ? '/logonew_words2.png' : '/logonew.png'
  
  const wordsDimensions = {
    small: { width: 65, height: 65 },
    medium: { width: 153, height: 153 },
    large: { width: 206, height: 206 }
  }

  const iconDimensions = {
    small: { width: 29, height: 29 },
    medium: { width: 42, height: 42 },
    large: { width: 59, height: 59 }
  }

  const baseDimensions = (variant === 'words' ? wordsDimensions : iconDimensions)[size]
  const scale = increasedSize ? 1.25 : 1
  const dimensions = {
    width: Math.round(baseDimensions.width * scale),
    height: Math.round(baseDimensions.height * scale)
  }
  
  const img = (
    <Image
      src={logoSrc}
      alt="GovCon Data Logo"
      width={dimensions.width}
      height={dimensions.height}
      className="transition-all duration-200"
      priority
    />
  )

  return (
    <div className="relative">
      {linkDisabled ? img : <Link href="/">{img}</Link>}
    </div>
  )
} 